import React, { Component } from 'react';

export class PaddedBox extends Component {
    render() {
        return (
            <div className="padded-box">
                <div className="inner">
                    {this.props.children}
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/generic/PaddedBox.jsx